import React from 'react';
import { useSelector } from 'react-redux';


import TranslationToolComponent from '../../components/TranslationTool';

const TranslationTool = (props) => <TranslationToolComponent {...props} />;

const TranslationToolContainer = (props) => {
  const state = useSelector((state) => ({
    homeHub: state.homeHub.homeHub || []
  }));

  const actions = {};

  return <TranslationTool {...props} {...state} {...actions} />;
};

export default TranslationToolContainer;
